import React from 'react';
import CaseTemplate from './templates/CaseTemplate';
import UploadedByTemplate from './templates/UploadedByTemplate';
import GlobalActionsTemplate from './templates/GlobalActionsTemplate/GlobalActionsTemplate';
import { TitleTemplate } from './templates/TitleTemplate';
import SizeTemplate from './templates/SizeTemplate';
import PagesTemplate from './templates/PagesTemplate';
import SignatureTemplate from './templates/SignatureTemplate';
import LastEditedTemplate from './templates/LastEditedTemplate';
import UploadedTemplate from './templates/UploadedTemplate';

/**
 * @param {Object} params - userContext, isClientFileManager, isGlobalFileManager, isFirmDocuments, modals, setSelectedFile, itemsRef, caseDetails, handleGetFiles, pageLimit, breadCrumbs
 */
export function getGlobalColumns(params) {
  const {
    userContext,
    isClientFileManager,
    isGlobalFileManager,
    isFirmDocuments,
    modals,
    setSelectedFile,
    itemsRef,
    caseDetails,
    handleGetFiles,
    pageLimit,
    breadCrumbs,
  } = params;

  const fileNameBody = (rowData, event) => (
    <>
      <div className="w-100 d-flex align-items-center gap-2">
        {rowData?.is_read === false && (
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: 'var(--primary-main)', flexShrink: 0 }} />
        )}
        <span
          className="w-100"
          style={{
            fontWeight: rowData?.is_read === false ? 'bold' : 'normal',
            color: rowData?.is_read === false ? 'var(--primary-dark)' : 'inherit',
          }}
        >
          <TitleTemplate
            rowData={rowData}
            event={event}
            isClientFileManager={isClientFileManager}
            isGlobalFileManager={isGlobalFileManager}
          />
        </span>
      </div>

      {rowData?.tags && rowData.tags.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
          {rowData.tags.map((tag, index) => (
            <span key={index} className="tag-grey">
              {tag}
            </span>
          ))}
        </div>
      )}
    </>
  );

  const signatureStatusBody = (rowData) => (
    <SignatureTemplate
      rowData={rowData}
      modals={modals}
      setSelectedItem={setSelectedFile}
      isClientFileManager={isClientFileManager}
      isLeadFileManager={params.isLeadFileManager}
      onSignClick={() => {}}
    />
  );

  const actionsBody = (rowData, event) => (
    <div className="text-right d-flex w-100 align-items-center">
      <GlobalActionsTemplate
        rowData={rowData}
        e={event}
        itemsRef={itemsRef}
        caseDetails={caseDetails}
        onDownloadComplete={() => handleGetFiles(pageLimit, breadCrumbs?.[breadCrumbs.length - 1]?.value)}
      />
    </div>
  );

  const allGlobalColumns = [
    {
      field: 'display_name',
      header: 'File Name',
      body: fileNameBody,
      sortable: true,
      bodyClassName: 'fileManager-name',
    },
    {
      field: 'case_name',
      header: 'Case',
      headerClassName: 'case-column-header',
      body: (rowData) => <CaseTemplate rowData={rowData} />,
      sortable: true,
      bodyClassName: 'ellipsis-text',
    },
    {
      field: 'user_full_name',
      header: 'Uploaded By',
      headerClassName: 'css-uploaded-by-column-header',
      body: (rowData) => <UploadedByTemplate rowData={rowData} />,
      sortable: true,
    },
    {
      field: 'time',
      header: 'Date Created',
      body: (rowData) => <UploadedTemplate userContext={userContext} rowData={rowData} isClientFileManager={isClientFileManager} />,
      sortable: true,
    },
    {
      field: 'updated',
      header: 'Date Modified',
      body: (rowData) => <LastEditedTemplate userContext={userContext} rowData={rowData} isClientFileManager={isClientFileManager} />,
      sortable: true,
    },
    {
      field: 'size',
      header: 'Size',
      headerClassName: 'css-size-column-header',
      body: (rowData) => <SizeTemplate rowData={rowData} />,
      sortable: true,
      bodyClassName: 'ellipsis-text',
    },
    {
      field: 'pages',
      header: 'Pages',
      headerClassName: 'css-pages-column-header',
      body: (rowData) => <PagesTemplate rowData={rowData} />,
      sortable: false,
      bodyClassName: 'ellipsis-text',
    },
    {
      field: 'esignature_status',
      header: 'Signature Status',
      headerClassName: 'signature-status-column-header',
      body: signatureStatusBody,
      sortable: true,
      bodyClassName: 'ellipsis-text',
    },
    {
      header: 'Actions',
      headerClassName: 'actions-column-header',
      body: actionsBody,
      exportable: false,
      className: 'fileManager-actions',
      fixed: true,
      width: '220px',
      field: 'action',
    },
  ];

  if (isFirmDocuments) {
    return allGlobalColumns.filter((col) => col.field !== 'case_name' && col.field !== 'esignature_status');
  }
  return allGlobalColumns;
}
